import React, { useEffect, useContext } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ApiService from '../../../services/ApiService'
import { AuthContext } from '../../../contexts/AuthContext'

const MagicLogin = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hash = searchParams.get('h')
  const { setToken } = useContext(AuthContext)

  useEffect(() => {
    const performMagicLogin = async () => {
      try {
        if (!hash) throw new Error('Hash ausente')

        const response = await ApiService.auth.magicLogin(hash)
        const { access_token, user } = response.data

        localStorage.setItem('token', access_token)
        setToken(access_token)
        setTimeout(() => {
          window.location.href = '/panel/steel/tracking'
        }, 100)
      } catch (err: any) {
        console.error('❌ Erro no Magic Login:', err)
        navigate('/login')
      }
    }

    performMagicLogin()
  }, [hash, navigate, setToken])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <p>Autenticando seu acesso...</p>
    </div>
  )
}

export default MagicLogin
